function markChatRead(params: { chatId: number }) {
    return window.apiCoreSingleton.get(`/api/admin/crm/employeechat/read/all/${params.chatId}`);
}

function markAllChatsRead() {
    return window.apiCoreSingleton.get(`/api/admin/crm/employeechat/read/all`);
}

export { markChatRead, markAllChatsRead };
